// Webpack Imports
import * as bootstrap from 'bootstrap';
import '@popperjs/core';
import ScrollReveal from 'scrollreveal'
import { multipleSelect } from 'multiple-select-vanilla';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );


	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	let aboveFoldUnloadedContent = document.querySelectorAll('.above-fold-not-loaded');
	let animatedContent = document.querySelectorAll('.animate-me');
	window.addEventListener('load', function() {
		if(aboveFoldUnloadedContent.length > 0) {
			aboveFoldUnloadedContent.forEach(item => {
				item.classList.remove('above-fold-not-loaded');
			});
		}

		ScrollReveal().reveal('.animate-me', {
			delay: 100,
			distance: '25px',
			viewOffset: {
				top: 80
			}
		});
	});

	// if (document.body.classList.contains('page-template-front')) {
	// 	let isSmallScreen = window.innerWidth < 1200;
	// 	window.addEventListener('resize', function() {
	// 		const currentIsSmallScreen = window.innerWidth < 1200;
	// 		if (currentIsSmallScreen !== isSmallScreen) {
	// 			console.log('a');
	// 			isSmallScreen = currentIsSmallScreen;
	// 			// ScrollReveal().sync();
	// 		}
	// 	});
	// }


	document.addEventListener('DOMContentLoaded', () => {
		const open_flyout = document.getElementById('open-flyout-menu');
		const close_flyout = document.getElementById('close-flyout-menu');
		const header = document.getElementById('header');
		const body = document.querySelector('body');

        // multipleSelect('select[multiple]');
	
		open_flyout.addEventListener('click', () => {
			body.classList.add('flyout-menu-open');
		});
		
		close_flyout.addEventListener('click', () => {
			body.classList.remove('flyout-menu-open');
		})

		if(body.classList.contains('page-template-blog-archive')) {
			const dropdownToggles = document.querySelectorAll('#navbar .navbar-nav .dropdown-toggle');
			dropdownToggles.forEach(function(el) {
				el.addEventListener('click', function() {
					if(this.classList.contains('show')) {
						header.classList.add('menu-dropdown-open');
					} else {
						header.classList.remove('menu-dropdown-open');
					}
				});
			});
		}
	});

	function enforceStickyNavPadding() {
		const scrollTop = document.documentElement.scrollTop;

		const body = document.getElementsByTagName('body')[0];
		const nav = document.getElementById('header');

		let navHeight = nav.offsetHeight;
		
		if(scrollTop > 0) {
			nav.classList.add('has-scrolled');
            body.style.paddingTop = navHeight + 'px';
		} else {
			nav.classList.remove('has-scrolled');
            body.style.paddingTop = 0;
		}
	}

	window.addEventListener('load', enforceStickyNavPadding);
	window.addEventListener('resize', enforceStickyNavPadding);
	window.addEventListener('scroll', enforceStickyNavPadding);

	// const jsSelectItems = document.querySelectorAll('.js-select');
    const multiSelectElement = document.querySelector('select[multiple]');

	if(multiSelectElement) {
		let options = {
			placeholderValue : 'Please select one or multiple trees to order',
			searchPlaceholderValue : 'Search',
			searchFields : ['label'],
			searchEnabled: true,
			position: 'bottom',
			removeItemButton: true,
		}

		const choicesElement = new Choices(multiSelectElement, options);
		const choicesInput = document.querySelector('input[type="search"].choices__input');

		let isDropdownOpen = false;

		multiSelectElement.addEventListener('showDropdown', function(event) {
			setTimeout(function() {
				isDropdownOpen = true; 
			}, 200);
		}, false);
		
		multiSelectElement.addEventListener('hideDropdown', function(event) {
			console.log('b');
			isDropdownOpen = false;
		}, false);
	
		// Toggle dropdown on click
		choicesInput.addEventListener('click', function(event) {
			if (isDropdownOpen) {
				choicesElement.hideDropdown();
				isDropdownOpen = false;
			}
		});
	}

	const choicesListMultiple = document.querySelector('.choices');
	const sectionTitle = document.querySelector('.section-title');
	if(choicesListMultiple) {
		choicesListMultiple.addEventListener('click', function(e) {
			if(choicesListMultiple.getAttribute('aria-expanded')) {
				// sectionTitle.click();
			}
		});
	}

	// Select all dropdown toggle elements
	const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

	if(dropdownToggles) {
		dropdownToggles.forEach(function(toggle) {
			// Bootstrap 5 dropdown instance
			const dropdown = new bootstrap.Dropdown(toggle);
		
			// Mouse enter event to show the dropdown
			if(window.innerWidth > 1024) {
				toggle.addEventListener('mouseenter', function() {
					dropdown.show();
					toggle.classList.add('mouse-enter-no-focus');
				});
			
				toggle.addEventListener('mouseleave', function(event) {
					setTimeout(() => {
						if (!toggle.parentElement.contains(document.activeElement)) {
							toggle.classList.remove('mouse-enter-no-focus');
							dropdown.hide();
						}
					}, 100); // Adjust delay as necessary
				});
			
				// Get the dropdown menu element
				const dropdownMenu = toggle.nextElementSibling;
			
				// Hide the dropdown when the mouse leaves the dropdown menu
				dropdownMenu.addEventListener('mouseleave', function(event) {
					setTimeout(() => {
						if (!dropdownMenu.contains(document.activeElement)) {
							toggle.blur();
							toggle.classList.remove('mouse-enter-no-focus');
							dropdown.hide();
						}
					}, 200);
				});
			}
		});
	}


	const toggleResultsButton = document.getElementById('toggle-results');
	if(toggleResultsButton) {
		const marketMap = document.getElementById('market-map');
		toggleResultsButton.addEventListener('click', function() {
			marketMap.classList.toggle('results-hidden');
		});
	}
} )();